export const ENVIRONMENTS = {
  PRODUCTION: `production`,
  STAGE: `stage`
} as const

export type EnvKey = typeof ENVIRONMENTS[keyof typeof ENVIRONMENTS];